import { render, staticRenderFns } from "./TouConfig.vue?vue&type=template&id=7dbfdfb0"
import script from "./TouConfig.vue?vue&type=script&lang=ts"
export * from "./TouConfig.vue?vue&type=script&lang=ts"
import style0 from "./TouConfig.vue?vue&type=style&index=0&id=7dbfdfb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports